import { useSelector } from "react-redux";
import { useGlobalData } from "@redux/slices/globalSlice";
import { useInitialUrl } from "@utils/useInitialUrl";
import { ProductCategory, ProductPrefixCategory } from "@utils/constants";

export const useProductPrefix = (product_type?: string) => {
  const { products } = useGlobalData();
  const activeProduct = useSelector(
    (state: any) => state.appState?.activeProduct
  );
  const { initialUrl } = useInitialUrl();
  const segments = initialUrl?.match(/\/webapp\/([^/]+)/);

  const resolvedType = product_type || activeProduct;
  const catalogPrefix = products?.[resolvedType]?.product_prefix;
  const labGrownPrefix =
    resolvedType === ProductCategory.LABGROWN_JEWELRY ||
    resolvedType === ProductPrefixCategory.LAB_GROWN_JEWELRY
      ? ProductPrefixCategory.LAB_GROWN_JEWELRY
      : undefined;

  const productPrefix =
    catalogPrefix ||
    labGrownPrefix ||
    resolvedType ||
    segments?.[1] ||
    activeProduct;
  return productPrefix;
};
